/**
 * en-GB messages added by Phase 3 task S30 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 * Sign-in check reasons (`check.*`, `error.sign_in_refused`) and `error.permit_open` are in arch.ts.
 */
export const s30EnGB = {
    'settings.visits.offline.offlineMinAgeSeconds': 'Treat a kiosk event as offline only if it reaches the server at least this many seconds after the time the kiosk claims (0 = trust the kiosk)',
    'error.group_not_on_contactless': 'This group is not available for contactless sign-in.',
    'error.upload_not_found': 'A photo or signature has not arrived. Please try again.',
    'visit.kiosk_event.reviewed': 'Marked as reviewed.',
    'visit.event.override': 'Signed in past a refused check by a team member.',
};
//# sourceMappingURL=s30.js.map